/**
 * The recording notice is a toast (decision 73): "This call is recorded",
 * a red dot, at the top of the stage for 3 seconds, nothing to tap. Every
 * call while it is recorded (docs/call-recording.md; it was booked lessons
 * only before every call was recorded), once a browser session, and never once the other person has
 * joined: the person who arrives second never sees it, and it goes the
 * moment the other side comes in. Pure, so tested.
 */
export const RECORDING_TOAST = 'This call is recorded';
export const RECORDING_TOAST_MS = 3000;

export type ToastStep = 'waiting' | 'shown' | 'gone';

/** The next step, from this side's join and the other person's presence. */
export function recordingToastStep(p: {
  step: ToastStep; recorded: boolean; seenThisSession: boolean; joined: boolean; presenceKnown: boolean; theyAreIn: boolean;
}): ToastStep {
  if (!p.recorded || p.seenThisSession) return 'gone';
  if (p.step === 'shown') return p.theyAreIn ? 'gone' : 'shown';
  if (p.step === 'waiting' && p.joined && p.presenceKnown) return p.theyAreIn ? 'gone' : 'shown';
  return p.step;
}
